$(document).ready(function() {
    $("[data-fancybox='gallery']").fancybox({
        thumbs: {
            autoStart: true
        },
        buttons: [
            "zoom",
            "slideShow",
            "thumbs",
            "close"
        ],
        transitionEffect: "slide",  // Animation type: "fade", "slide", "zoom-in-out", "circular", etc.
        transitionDuration: 500     // Duration of the animation in milliseconds
    });
});


  AOS.init();
